const DATE_PLACEHOLDER = "—";
const DEFAULT_TIME_ZONE = process.env.REACT_APP_TIMEZONE || "Asia/Dhaka";

const parseDateValue = (value: unknown): Date | null => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string" || typeof value === "number") {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
};

const fallbackText = (value: unknown): string => {
  if (value === null || value === undefined) {
    return DATE_PLACEHOLDER;
  }

  if (typeof value === "string") {
    return value.length ? value : DATE_PLACEHOLDER;
  }

  return String(value);
};

export const toDateInputValue = (value?: string | null): string => {
  if (!value) {
    return "";
  }

  const parsed = parseDateValue(value);
  if (parsed) {
    return parsed.toISOString().slice(0, 10);
  }

  if (typeof value === "string") {
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : "";
  }

  return "";
};

export const toRangeStartIso = (value?: string) => (value ? value : undefined);

export const toRangeEndIso = (value?: string) => (value ? value : undefined);

export const formatDate = (
  value: unknown,
  locale?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions
): string => {
  const parsed = parseDateValue(value);
  if (parsed) {
    const resolvedOptions: Intl.DateTimeFormatOptions = {
      timeZone: DEFAULT_TIME_ZONE,
      ...options,
    };
    return parsed.toLocaleDateString(locale, resolvedOptions);
  }

  return fallbackText(value);
};

export const formatDateTime = (
  value: unknown,
  locale?: Intl.LocalesArgument,
  timeOptions?: Intl.DateTimeFormatOptions
): string => {
  const parsed = parseDateValue(value);
  if (parsed) {
    const resolvedTimeOptions: Intl.DateTimeFormatOptions = {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: DEFAULT_TIME_ZONE,
      ...timeOptions,
    };
    const datePart = parsed.toLocaleDateString(locale, { timeZone: DEFAULT_TIME_ZONE });
    const timePart = parsed.toLocaleTimeString(locale, resolvedTimeOptions);
    return `${datePart} ${timePart}`;
  }

  return fallbackText(value);
};
